import { getArrayTree } from './function'
import loading from './loading'

export const getRecruitmentState = {
  methods: {
    getRecruitmentState (val) {
      let state = ''
      switch (Number(val)) {
        case 1:
          state = '正在招聘'
          break
        case 2:
          state = '暂停招聘'
          break
        case 3:
          state = '成功招聘'
          break
        case 4:
          state = '终止招聘'
          break
      }
      return state
    }
  }
}

export const EducationMinix = {
  data () {
    return {
      educationList: []
    }
  },
  created () {
  },
  methods: {

    getEducationName (id) {
      let educationName = ''
      this.educationList.forEach((item) => {
        if (item.Id === id) {
          educationName = item.Description
        }
      })
      return educationName
    }
  }
}


export const OnTheBlackListnMinix = {
  data () {
    return {}
  },
  created () { },
  methods: {
    OnTheBlackList (tel) {
      return new Promise((resolve, reject) => {
        this.$api.BlackListInfo.OnTheBlackList(tel).then((res) => {
          if (res.error == false) {
            if (res.data) {
              // ========== 核心改造：仅按分号（中英文）拆分 ==========
              // 拆分规则：只匹配 ; 或 ；，过滤空字符串
              const msgArr = res.msg.split(/[;；]/).filter(item => item.trim());

              let confirmContent = '';
              if (msgArr.length > 1) {
                // 多条信息：列表化展示，更清晰
                confirmContent = `<div style="text-align: left; line-height: 1.8; padding: 10px 0;">
                  <div style="margin-bottom: 8px; font-weight: 500;">检测到以下黑名单信息：</div>
                  <ul style="margin: 0; padding-left: 20px; color: #666;">
                    ${msgArr.map(item => `<li style="margin: 4px 0;">${item.trim()}</li>`).join('')}
                  </ul>
                  <div style="margin-top: 10px;">是否确认继续操作？</div>
                </div>`;
              } else {
                // 单条信息：简洁展示
                confirmContent = `${msgArr[0]?.trim() || res.msg}，是否确认继续操作？`;
              }

              // 弹出富文本确认框
              this.$confirm(
                confirmContent,
                '黑名单提示',
                {
                  confirmButtonText: '确定继续',
                  cancelButtonText: '取消',
                  type: 'warning',
                  dangerouslyUseHTMLString: true, // 允许渲染HTML
                  center: true, // 居中展示

                }
              ).then(() => {
                resolve(true);
              }).catch(() => {

              });
            } else {
              resolve(true);
            }
          } else {

          }
        }).catch((err) => {

        });
      });
    }
  }
}
export const getCitysMinix = {
  data () {
    return {
      cityList: []
    }
  },
  created () {
    // this.getCityList();
  },
  methods: {
    getCityList () {
      this.$api.base.getCitys().then((res) => {
        if (res.Error === false) {
          this.cityList = getArrayTree(res.Data, 'Id', 'ParentId')
        }
      })
    }
  }
}

export const getUsersMinix = {
  data () {
    return {
      users: []
    }
  },
  created () {
    this.getAllUser()
  },
  methods: {
    getAllUser () {
      var menuId = this.$route.meta.menuId || window.sessionStorage.getItem('mRportId') || 0
      this.$api.user.getAllUser(menuId).then((res) => {
        if (res.code === 0) {
          this.users = res.data
        }
      })
    }
  }
}

export const AdDetails = {
  data () {
    return {

    }
  },
  created () {

  },
  methods: {
    getAdDetails (id, _this, name) {
      let sendData = {
        id: id,
        loading: false
      }
      this.$api.manage.AdvertisingManageDetail(sendData).then((res) => {
        if (res.code === 0) {
          if (res.data && !res.data.isStop) {
            _this[name] = res.data
          }
        }
      })
    }
  }
}


export const GetUnlimitedQRCodeMinix = {
  data () {
    return {}
  },
  created () { },
  methods: {
    GetUnlimitedQRCode (value) {
      console.log(value)
      let sendData = value
      //体验版
      // sendData.env_version = 'trial'
      // 开发版
      // sendData.env_version = 'develop'
      // 正式版
      // sendData.env_version = 'release'
      sendData.env_version = process.env.VUE_APP_WEIXIN_EDITION

      return new Promise((resolve, reject) => {
        this.$api.thirdyParty.GetUnlimitedQRCode(sendData).then((res) => {
          if (res.code == 0) {
            resolve(res.data)
          } else {
            this.$message.error(res.msg)
          }
        })
      })
    }
  }
}

export const verifyPermissionMinix = {
  data () {
    return {
      currentMenuAuth: []
    }
  },
  mounted () {
    this.getCurrentMenuAuth()
  },
  methods: {
    getCurrentMenuAuth () {
      const menuId = this.$route.meta.menuId
      this.$api.user.getRightsMenus(menuId).then((res) => {
        if (res.code === 0) {
          this.currentMenuAuth = JSON.parse(res.data)
          if (!this.currentMenuAuth || this.currentMenuAuth.length === 0) {
            this.$message.error('权限不足')
            setTimeout(() => {
              this.$router.replace('/home')
            }, 1000)
          }
        }
      })
    },
    verifyPermission (value) {
      if (!this.currentMenuAuth || this.currentMenuAuth.length === 0) return
      let isShow = true
      const item = this.currentMenuAuth.filter((v) => v.value === value)
      if (item.length === 0) {
        isShow = false
      }
      return isShow

      return true
    }
  }
}


export const btnVerifyPermissionMinix = {
  data () {
    return {
      currentMenuAuth: []
    }
  },
  mounted () {
  },
  methods: {
    getCurrentMenuAuth (id, value) {
      const menuId = id

      this.$api.user.getRightsMenus(menuId).then((res) => {
        if (res.code === 0) {
          this.currentMenuAuth = JSON.parse(res.data)
          if (!this.currentMenuAuth || this.currentMenuAuth.length === 0) {
            return false
          }
          let isShow = true
          const item = this.currentMenuAuth.filter((v) => v.value === value)
          if (item.length === 0) {
            isShow = false
          }
          return isShow
        }
      })
    }
  }
}

/**
 * 生成倒计时 mixin，按秒进行倒计时
 * @param {string} getterKey 要注入的属性名，改属性可读写，用于获取或设置剩余秒数
 * @param {string} localName 本地存储名称
 * @param {string} [setterKey] 要注入的方法名，可选，改方法用于重置剩余秒数
 *
 * @example 传入一个字符串参数，注入一个可读写的属性用于取值和重置
 * <template>
 *   <button :disabled="!!seconds" @click="seconds = 60">
 *     {{ seconds || '发送验证码' }}
 *   </button>
 * </template>
 * <script>
 * import countdown from '@/mixins/countdown'
 * export default {
 *   mixins: [
 *     countdown('seconds')
 *   ]
 * }
 * </script>
 *
 * @example 传入第二个字符串参数，再注入一个重置的方法
 * <template>
 *   <button :disabled="!!seconds" @click="setCountdown(60)">
 *     {{ seconds || '发送验证码' }}
 *   </button>
 * </template>
 * <script>
 * import countdown from '@/mixins/countdown'
 * export default {
 *   mixins: [
 *     countdown('seconds', 'setCountdown')
 *   ]
 * }
 * </script>
 */
export function countdown (getterKey, setterKey, localName) {
  if (typeof getterKey === "string") {
    const mixin = {
      data () {
        return {
          // 属性注入到 data 中
          [getterKey]: 0,
        };
      },
      created () {
        let timer = null;
        this.$watch(
          getterKey,
          (val, oldVal) => {
            if (timer !== null) {
              clearTimeout(timer);
              timer = null;
            }
            // 非数字类型转成数字类型
            if (typeof val !== "number") {
              this[getterKey] = Number(val);
              return;
            }
            // 非法值，转成 0
            if (!isFinite(val)) {
              this[getterKey] = 0;
              return;
            }
            // 负数，转成 0
            if (val < 0) {
              this[getterKey] = 0;
              return;
            }
            // 小数，向上取整
            if (val % 1 !== 0) {
              this[getterKey] = Math.ceil(val);
              return;
            }
            if (val > 0) {
              if (localName) {
                window.localStorage.setItem(localName, val)
              }
              if (val == 1 && localName) {
                window.localStorage.removeItem(localName)
              }
              timer = setTimeout(
                () => {
                  this[getterKey] = val - 1;
                },
                // 整数时倒计时 1s，小数时倒计时超出整数秒的时间
                oldVal % 1 > 0 ? (oldVal * 1000) % 1000 : 1000
              );
            }
          },
          {
            immediate: true,
          }
        );
        // 组件销毁时清除定时器
        this.$on('hook:destroyed', () => {
          if (timer !== null) {
            clearTimeout(timer)
          }
        })
      },
    };
    if (typeof setterKey === "string") {
      // 再注入一个方法
      mixin.methods = {
        [setterKey] (val) {
          this[getterKey] = val;
        },
      };
    }
    return mixin;
  }
  // 参数不规范时抛出错误
  throw new Error("Invalid arguments");
}